import { useEffect, useState } from 'react';

const isDarkNow = () => !!document.querySelector('[data-bs-theme="dark"]');

/**
 * Reactively detects dark/light mode and returns Chart.js-ready colour tokens.
 * Works with Bootstrap's data-bs-theme attribute on any ancestor element.
 */
export const useChartTheme = () => {
  const [dark, setDark] = useState(isDarkNow);

  useEffect(() => {
    const obs = new MutationObserver(() => setDark(isDarkNow()));
    obs.observe(document.body, {
      attributes: true,
      subtree: true,
      attributeFilter: ['data-bs-theme'],
    });
    return () => obs.disconnect();
  }, []);

  return {
    textColor: dark ? 'rgba(255,255,255,0.75)' : '#1E164D',
    gridColor: dark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
    isDark: dark,
  };
};
